// Mock data for JEE Exports & Imports website

export const companyInfo = {
  name: "JEE Exports & Imports",
  tagline: "Delivering Nature's Purity Worldwide",
  phone1: "+91 9345357386",
  phone2: "+91 8754371909",
  email: "jeeexportsandimports@gmail.com",
  description: "Leading manufacturer of premium organic vetiver products, committed to purity, sustainability, and international quality standards.",
};

export const products = [
  {
    id: 1,
    name: "Organic Vetiver Essential Oil",
    description: "100% pure steam-distilled essential oil with a rich earthy aroma. Ideal for perfumery, aromatherapy, and cosmetics.",
    features: ["100% Pure", "Steam Distilled", "Rich Earthy Aroma", "Therapeutic Grade"],
    applications: ["Perfumery", "Aromatherapy", "Cosmetics", "Skincare"],
    image: "https://images.unsplash.com/photo-1512867957657-38dbae50a35b",
  },
  {
    id: 2,
    name: "Organic Vetiver Roots",
    description: "Cleaned and dried vetiver roots, perfect for cooling, aromatic, and herbal applications.",
    features: ["Cleaned & Dried", "100% Organic", "Premium Quality", "Export Grade"],
    applications: ["Herbal Medicine", "Cooling Applications", "Aromatic Uses", "Traditional Medicine"],
    image: "https://customer-assets.emergentagent.com/job_agri-commerce-14/artifacts/tiwaim7e_image.png",
  },
  {
    id: 3,
    name: "Organic Vetiver Powder",
    description: "Finely processed vetiver powder, widely used in skincare formulations and herbal products.",
    features: ["Finely Processed", "Premium Grade", "100% Natural", "Versatile Use"],
    applications: ["Skincare Products", "Herbal Formulations", "Cosmetic Manufacturing", "Traditional Remedies"],
    image: "https://customer-assets.emergentagent.com/job_agri-commerce-14/artifacts/x7g7d0e5_image.png",
  },
];

export const whyChooseUs = [
  {
    title: "100% Organic Products",
    description: "Certified organic vetiver sourced directly from trusted farms, ensuring purity and authenticity.",
    icon: "Leaf",
  },
  {
    title: "International Quality Standards",
    description: "Every product meets stringent international quality benchmarks for global export compliance.",
    icon: "Award",
  },
  {
    title: "Direct Manufacturing",
    description: "In-house manufacturing facility ensures complete control over quality and eliminates middlemen.",
    icon: "Factory",
  },
  {
    title: "Strict Quality Control",
    description: "Rigorous quality checks at every production stage, from raw material to finished product.",
    icon: "ShieldCheck",
  },
  {
    title: "Bulk Supply Capability",
    description: "Equipped to handle large-scale orders with consistent quality and timely delivery.",
    icon: "Package",
  },
  {
    title: "Competitive Pricing",
    description: "Direct manufacturing and efficient processes allow us to offer premium products at competitive rates.",
    icon: "DollarSign",
  },
];

export const services = [
  {
    title: "Export-Compliant Packaging",
    description: "Custom-designed materials with regulatory approval for global shipping standards.",
  },
  {
    title: "Custom Bulk Packing",
    description: "Flexible solutions from small bags to large drums and crates, accommodating various quantity requirements.",
  },
  {
    title: "Safe & Timely Delivery",
    description: "Partnering with trusted logistics networks for trackable, secure shipments worldwide.",
  },
];
